var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WebsiteHeader',_vm._b({directives:[{name:"intersect",rawName:"v-intersect",value:({ onProgress: _vm.progressChangeHandler, rootMargin: '-72px 0px 0px 0px' }),expression:"{ onProgress: progressChangeHandler, rootMargin: '-72px 0px 0px 0px' }"}]},'WebsiteHeader',_vm.websiteHeaderProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }